import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleReviews() {
  const article = seoArticles.find((a) => a.slug === "recenzja-spolecznosci-kakobuy-spreadsheet-2026")!;
  return <ArticleLayout article={article} />;
}